import { effect, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectUser } from '../../store/app.selectors';

import { AppState } from '../../app.reducer';
import { DealerSettingName } from '../../modules/chat/interfaces/IDealerSettings';
import { setDarkmode } from '../../modules/shared/store/ui.actions';

@Injectable()
export class DarkModeService {
  private store = inject(Store<AppState>);

  user = toSignal(this.store.select(selectUser), { initialValue: null });
  darkMode: boolean;
  dealerTheme = 'default';
  dealerLogo = '';

  constructor() {
    effect(() => {
      this.setDealerTheme();
      this.setDealerLogo();
    });
  }

  toggleDarkmode(state: boolean) {
    if (state) {
      document.documentElement.setAttribute('data-theme', `${this.dealerTheme}-dark`);
      localStorage.setItem('data-theme', `${this.dealerTheme}-dark`);
    } else {
      document.documentElement.setAttribute('data-theme', `${this.dealerTheme}-light`);
      localStorage.setItem('data-theme', `${this.dealerTheme}-light`);
    }
    this.darkMode = state;
    this.store.dispatch(setDarkmode({ value: state }));
  }

  setTheme(): void {
    const theme = localStorage.getItem('data-theme');
    this.toggleDarkmode(theme ? theme.includes('dark') : false);
  }

  setDealerTheme(): void {
    const user = this.user();
    if (!user) {
      this.dealerTheme = 'default';
    } else {
      const dealerTheme = user?.dealerSettings?.length
        ? user.dealerSettings.find((e) => e.key === DealerSettingName.dealerTheme)
        : null;
      if (!dealerTheme) {
        this.dealerTheme = 'default';
      } else {
        const theme = dealerTheme.children?.length
          ? dealerTheme.children.find((e) => e.key === DealerSettingName.theme)
          : null;
        this.dealerTheme = theme?.value || 'default';
      }
    }
  }

  setDealerLogo(): void {
    const user = this.user();
    if (user) {
      const dealerTheme = user?.dealerSettings?.length
        ? user.dealerSettings.find((e) => e.key === DealerSettingName.dealerTheme)
        : null;
      if (dealerTheme) {
        const theme = dealerTheme.children?.length
          ? dealerTheme.children.find((e) => e.key === DealerSettingName.logo)
          : null;
        this.dealerLogo = theme?.value ?? '';
      }
    }
  }
}
